import React from "react";
import { Container, Row, Col } from "reactstrap"
import { Link } from "@reach/router";
import roomImage from "../assets/room.jpg";
import teaRoomImage from "../assets/modernTeaRoom.JPG";
import sandwichImage from "../assets/scones.jpg";
import courtyardImage from "../assets/courtyard2.jpeg";
import accommodationImage from "../assets/IMG_0399.JPG";
import galleryImage from "../assets/IMG_0148.jpg";
import contactImage from "../assets/teaRoom.jpg";
import christmasMenuImage from "../assets/christmasdinner.png"; 
import christmasMenu from "../assets/WhiteHart2026XmasMenu.pdf"
import "./app.css";

const Home = () => {
    const homeLinks = [
        {
            title: "Christmas Menu 2026",
            to: christmasMenu,
            openInNewWindow: true,
            subtitle: "Christmas Menu and Booking Form",
            image: christmasMenuImage,
        },
        {
            title: "About Us",
            to: "/visit",
            subtitle: "More about us including parking info.",
            image: contactImage,
        },
        {
            title: "Tearoom & Menu",
            to: "/tearoom",
            subtitle: "Breakfasts, mains, cakes and more",
            image: teaRoomImage,
        },
        {
            title: "Afternoon Teas",
            to: "/afternoon-teas",
            subtitle: "Prebookable teas with vegan and GF options",
            image: sandwichImage,
        },
        {
            title: "Sandwich Bar",
            to: "/foodtogo",
            subtitle: "Fresh takeaway favourites",
            image: sandwichImage,
            backgroundPosition: "center 72%",
        },
        {
            title: "Our Courtyard",
            to: "/courtyard",
            subtitle: "Discover our outdoor courtyard space",
            image: courtyardImage,
        },
        {
            title: "Accommodation",
            to: "/accommodation",
            subtitle: "Cosy en-suite rooms for your stay",
            image: accommodationImage,
        },
        {
            title: "Gallery",
            to: "/gallery",
            subtitle: "See the White Hart experience",
            image: roomImage,
        },
        {
            title: "Contact Us",
            to: "/contact",
            subtitle: "Call, email, or send us a message",
            image: galleryImage,
        }
    ];


    return (
        <Container fluid>
            <Row className="row-m-20">
                <Col className="remove-padding">
                    <div className="home-page-shell">
                        <div className="home-nav-stack">
                        {homeLinks.map((item) => {
                            const tileProps = {
                                className: "home-nav-tile",
                                style: {
                                    backgroundImage: `linear-gradient(180deg, rgba(210,210,210,0.86), rgba(210,210,210,0.72)), url(${item.image})`,
                                    backgroundPosition: item.backgroundPosition || "center"
                                }
                            };
                            const content = (
                                <>
                                    <span className="home-nav-title">{item.title}</span>
                                    <span className="home-nav-subtitle">{item.subtitle}</span>
                                </>
                            );

                            return item.openInNewWindow ? (
                                <a
                                    key={item.title}
                                    href={item.to}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    {...tileProps}
                                >
                                    {content}
                                </a>
                            ) : (
                                <Link key={item.title} to={item.to} {...tileProps}>
                                    {content}
                                </Link>
                            );
                        })}
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Home;



